import React from 'react';
import {observer} from 'mobx-react';
import * as moment from 'moment';
import formatDuration from 'format-duration';
import classNames from 'classnames';

import {EditableField} from '../../../common/editable-field';
import {FlagButton} from '../../../common/flag-button';
import {Icon} from 'antd';
import {PhoneNumber} from '../../../common/phone-number';
import {formatContactType} from '../../../../utils/format-contact-type';

@observer
export class CallItem extends React.Component {
  render() {
    const { call } = this.props;
    const { data } = call;

    const className = classNames(
      'call-item',
      data.important ? 'call-item--important' : '',
      data.is_lost ? 'call-item--lost' : ''
    );

    return (
      <div className={className}>
        <div className="call--state">
          <FlagButton enabled={data.important} onChange={imp => call.updateImportant(imp)} />
        </div>
        <div className="call--date">{this.formatDate(data.start_time)}</div>
        <div className="call--type">{this.formatDirection(data.direction)}</div>
        <div className="call--status">{this.formatStatus(data.is_lost)}</div>
        <div className="call--source">{data.scenario_name}</div>
        <div className="call--contact_phone"><PhoneNumber phone={data.contact_phone_number} /></div>
        <div className="call--contact_status">{formatContactType(data.contact_type)}</div>
        <div className="call--contact_name">{data.contact_name}</div>
        <div className="call--duration">{this.formatDuration(data.total_duration, data.full_record_file_link)}</div>
        <div className="call--comment">
          <EditableField
            value={data.comment}
            saving={call.isUpdatingComment}
            editing={call.isEditingComment}

            onStartEdit={this.startEditComment}
            onSave={this.saveComment}
            onCancel={this.stopEditComment}
          />
        </div>
      </div>
    )
  }


  formatStatus(is_lost) {
    return is_lost ? 'Потерян' : 'Принят';
  }

  formatDirection(direction) {
    return direction === 'in' ? 'Входящий' : 'Исходящий';
  }

  formatDate(date) {
    return moment(date).format('DD.MM.YYYY HH:mm:ss');
  }

  formatDuration(duration, link) {
    return (
      <div>
        {formatDuration(duration * 1000)}
        {link && <a href={link} target="_blank"><Icon type="play-circle" /></a>}
      </div>
    );
  }


  startEditComment = () => {
    this.props.call.startEditComment();
  }
  stopEditComment = () => {
    this.props.call.stopEditComment();
  }

  saveComment = (value) => {
    this.props.call.updateComment(value);
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/crm/call/call-item.js